<!--手动出账-->
<template>
  <div>
    <van-nav-bar :title="title" />
    <van-cell-group >
      <van-cell>
        <van-field
            readonly
            clickable
            label="付款方式"
            :value="payMode"
            placeholder="请选择"
            @click="showPayModesPicker = true"

        />
        <van-popup v-model="showPayModesPicker" position="bottom">
          <van-picker show-toolbar title="付款方式" ref="payModesPicker"
                      :columns="payModes"
                      value-key="remark"
                      @cancel="showPayModesPicker = false"
                      @confirm="onPayModesConfirm"/>
        </van-popup>
      </van-cell>
      <van-cell>
        <van-field
            :border=false
            readonly
            clickable
            label="出账月"
            :value="formModel.repeatMonth"
            placeholder="请选择"
            @click="showDatePicker = true"
        />
        <van-popup v-model="showDatePicker" position="bottom">
          <van-datetime-picker
              v-model="pickDate"
              type="year-month"
              :min-date="minDate"
              :max-date="maxDate"
              @cancel="showDatePicker = false"
              @confirm="onDateConfirm"
          />
        </van-popup>
      </van-cell>
      <van-cell>
        <van-button style="margin-top: 10px;" type="info" plain size="small"
                    block round  :loading="isLoading"
                    loading-text="出账..."
                    @click="calCredit">出账</van-button>
      </van-cell>

    </van-cell-group>
  </div>
</template>

<script>
import * as DateUtil from "@/common/utils/dateUtil";
import * as MyApi from "@/api/URLApiAddr";

export default {
  name: "CreditReportHandle",
  data() {
    return {
      title: '手动出账',
      formModel:{
        id: Number,
        repeatMonth: DateUtil.formatDate(new Date,'yyyy-MM')
      },
      pickDate:new Date(),
      showDatePicker:false,
      minDate: DateUtil.getMinDate(),
      maxDate: DateUtil.getMaxDate(),
      payModes:[],
      showPayModesPicker: false,
      payMode: "",
      isLoading: false
    }
  },
  created:function() {
    this.initData()
  },
  methods: {
    initData(){
      this.$axios.get(MyApi.QRY_CREDIT_CFG_LIST).then((response) => {

        if(response.code == 200){
          this.formModel.id = response.data[0].id
          this.payMode = response.data[0].remark
          this.payModes.push({values:response.data});
        }

      }).catch((error) => {

        this.$toast.fail("数据初始化异常"+error);
      })
    },
    onDateConfirm(value) {
      this.formModel.repeatMonth = DateUtil.formatDate(value,'yyyy-MM');
      this.showDatePicker = false;
    },
    onPayModesConfirm(value){
      this.formModel.id = value[0].id;
      this.payMode = value[0].remark ;
      this.showPayModesPicker = false
    },
    calCredit(){
      //this.$emit('calCredit', this.formModel)
      this.isLoading = true
      let params = this.formModel
      this.$axios.post(MyApi.QRY_CREDIT_AGAIN_BTN,params/*,options*/)
          // 请求成功后
          .then((data) => {
            //let data = response.data;
            if('200' == data.code){
              this.$toast.success(data.msg);
              this.$emit('calCredit', true);
            }
            this.isLoading = false
          })
          .catch((err) => {
            this.isLoading = false
            this.$toast.fail("请求异常,请稍后再试");
          })

    }
  }
}
</script>

<style scoped>

</style>